module.exports = __webpack_public_path__ + "media/images/features/draft/icon-point-03-3d4f6d166a36680ff38dc195ed908ff3.svg";